import { useEffect, useState } from 'react';
import { m as motion, AnimatePresence } from 'framer-motion';
import { css, cx, etiColors, mediaQueries } from '@eti/styles';
import fetchCarrierLogo from './utils/carrierLogo';
import { jsx as _jsx } from "react/jsx-runtime";
const sizeStyles = css`
  flex-shrink: 0;
  height: 20px;
  width: 20px;

  @media ${mediaQueries.medium.up} {
    height: 32px;
    width: 32px;
  }

  @media ${mediaQueries.large.up} {
    height: 40px;
    width: 40px;
  }
`;
const placeholderStyles = css`
  background-color: ${etiColors.grayScale[4]};
  border-radius: 3px;
`;
const motionVariantsForLogo = {
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      delay: 0.25,
      duration: 0.75
    }
  },
  exit: {
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.3
    }
  }
};
const motionVariantsForPlaceholder = {
  initial: {
    opacity: 0
  },
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.3
    }
  },
  exit: {
    opacity: 0,
    display: 'none',
    transition: {
      type: 'tween',
      duration: 0.15
    }
  }
};
const LegacyCarrierLogo = _ref => {
  let {
    'aria-hidden': ariaHidden,
    className = sizeStyles,
    'data-testid': dataTestId,
    id,
    imageAlt
  } = _ref;
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    let isUnmounted = false;
    const loadCarrierLogo = async iataCode => {
      const carrierLogo = await fetchCarrierLogo(iataCode);
      if (!isUnmounted) {
        setLogo(carrierLogo);
      }
    };
    loadCarrierLogo(id);
    return () => {
      isUnmounted = true;
    };
  }, [id]);
  return /*#__PURE__*/_jsx(AnimatePresence, {
    children: logo ? /*#__PURE__*/_jsx(motion.img, {
      alt: imageAlt,
      animate: "enter",
      "aria-hidden": ariaHidden,
      className: className,
      "data-testid": dataTestId,
      exit: "exit",
      initial: "exit",
      src: logo,
      variants: motionVariantsForLogo
    }, `${logo}`) : /*#__PURE__*/_jsx(motion.div, {
      animate: "enter",
      "aria-hidden": ariaHidden,
      className: cx(className, placeholderStyles),
      "data-testid": `${dataTestId}-no-logo`,
      exit: "exit",
      initial: "initial",
      variants: motionVariantsForPlaceholder
    }, "placeholder")
  });
};
const getSources = logo => ({
  src: logo.small,
  srcSet: `${logo.small} 1x,${logo.large} 2x`
});
const CarrierLogo = _ref2 => {
  let {
    'aria-hidden': ariaHidden,
    className = sizeStyles,
    'data-testid': dataTestId,
    id,
    imageAlt,
    logo
  } = _ref2;
  if (!logo) {
    return /*#__PURE__*/_jsx(LegacyCarrierLogo, {
      "aria-hidden": ariaHidden,
      className: className,
      "data-testid": dataTestId,
      id: id,
      imageAlt: imageAlt
    });
  }
  const {
    src,
    srcSet
  } = getSources(logo);
  return /*#__PURE__*/_jsx("img", {
    alt: imageAlt,
    "aria-hidden": ariaHidden,
    className: className,
    "data-testid": dataTestId,
    src: src,
    srcSet: srcSet
  });
};
export default CarrierLogo;
//# sourceMappingURL=CarrierLogo.js.map